// extracted by mini-css-extract-plugin
module.exports = {"curtain":"video-gallery_curtain__CZAsE","fadeIn":"video-gallery_fadeIn__JNuGn","gradientBox":"video-gallery_gradientBox__RlrLt","section":"video-gallery_section__v_yS1"};